import { __assign, __rest } from "tslib";
import React, { forwardRef } from "react";
import classNames from "classnames";
import { useConfig } from "../_util/config-context";
var DefaultStyle = {
// flex: 1,
// display: "flex",
// gap: "8px",
// fontSize: 12,
// lineHeight: "20px",
};
export var ListItemContent = forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, style = _a.style, restProps = __rest(_a, ["children", "className", "style"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement("div", __assign({ className: classNames(classPrefix + "-list__item-content", className), style: __assign(__assign({}, DefaultStyle), style), ref: ref }, restProps), children));
});
ListItemContent.displayName = "ListItemContent";
//# sourceMappingURL=ListItemContent.js.map